import angular from 'angular';
import helloPackDealOption from './helloPackDealOption';

export default angular
  .module('helloPack.scenes.helloPackDealOption.components', [])
  .component('helloPackDealOption', helloPackDealOption).name;
